import { IMultiSelectOption } from '@finder/features/list/components/multi-select/multi-select-option.interface';
import cloneDeep from 'lodash-es/cloneDeep';

export interface IMultiSelectService {
    options: IMultiSelectOption[];
    selected: string[];
    allOption: Partial<IMultiSelectOption>;
    optionSelected: string;
}

const IDefaults: IMultiSelectService = {
    options: [],
    selected: [],
    allOption: {},
    optionSelected: ''
};

export class MultiSelectServiceFactory {
    static create(options): IMultiSelectService {
        return cloneDeep({ ...IDefaults, ...options });
    }
}
